export const getAuthorizationToken = () => {
    if (typeof localStorage !== 'undefined' && localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      return obj?.token
    }
  }
  
  export const getUserID = () => {
    if (typeof localStorage !== 'undefined') {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      return obj?.userId
    }
  }
  
  export const LocalGetUser = () => {
    if (typeof localStorage !== 'undefined' && localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      return obj
    }
  }